/* Sagex swipeable product cards: swipe / drag the card image to change photos */
(function () {
  if (window.__sgxCardSwipe) return;
  window.__sgxCardSwipe = true;

  var MAX_IMAGES = 6;
  var MAX_PARALLEL = 4;
  var cache = {};
  var queue = [];
  var running = 0;

  /* ---------- styles ---------- */
  var css = '' +
    '.product-card-wrapper{touch-action:pan-y}' +
    '.sgx-swipe .sgx-track{display:flex;position:absolute;top:0;left:0;width:100%;height:100%;transition:transform .45s cubic-bezier(.2,.7,.2,1);will-change:transform}' +
    '.sgx-track img{flex:0 0 100%;width:100%;height:100%;max-width:none;object-fit:cover;position:static!important;-webkit-user-drag:none;user-select:none}' +
    '.sgx-dots{position:absolute;left:0;right:0;bottom:10px;display:flex;justify-content:center;gap:5px;z-index:4;pointer-events:none}' +
    '.sgx-dots i{display:block;width:5px;height:5px;border-radius:3px;background:rgba(255,255,255,.5);transition:width .3s ease,background .3s ease}' +
    '.sgx-dots i.on{width:15px;background:#d9c9a3}' +
    '.sgx-nav{position:absolute;top:50%;z-index:4;width:30px;height:30px;margin-top:-15px;padding:0;border-radius:50%;border:1px solid rgba(217,201,163,.45);background:rgba(5,5,5,.6);color:#d9c9a3;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s ease}' +
    '.sgx-nav svg{width:14px;height:14px}' +
    '.sgx-prev{left:8px}.sgx-next{right:8px}' +
    '.sgx-nav[hidden]{display:none}' +
    '@media(hover:hover){.product-card-wrapper:hover .sgx-nav{opacity:1}}' +
    '@media(hover:none){.sgx-nav{display:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- data loading (small parallel queue + cache) ---------- */
  function pump() {
    while (running < MAX_PARALLEL && queue.length) {
      running++;
      queue.shift()();
    }
  }
  function enqueue(fn) {
    return new Promise(function (resolve) {
      queue.push(function () {
        fn().then(resolve, function () { resolve([]); }).then(function () {
          running--;
          pump();
        });
      });
      pump();
    });
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function loadImages(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.images ? d.images.slice(0, MAX_IMAGES) : []; })
        .catch(function () { return []; });
    }
    return cache[handle];
  }
  function sized(u) {
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720';
  }

  /* ---------- build the slider on a card ---------- */
  var CHEV_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';

  function build(card, images) {
    if (card.__sgxBuilt) return;
    var media = card.querySelector('.card__media .media');
    var inner = card.querySelector('.card__inner');
    if (!media || !inner) return;
    var first = media.querySelector('img');
    if (!first) return;
    card.__sgxBuilt = true;

    /* remove the theme's hover-swap image, the slider replaces it */
    var imgs = media.querySelectorAll('img');
    for (var i = 1; i < imgs.length; i++) imgs[i].parentNode.removeChild(imgs[i]);

    var track = document.createElement('div');
    track.className = 'sgx-track';
    first.draggable = false;
    track.appendChild(first);

    var total = images.length;
    for (var j = 1; j < total; j++) {
      var im = new Image();
      im.src = sized(images[j]);
      im.alt = first.alt || '';
      im.loading = 'lazy';
      im.decoding = 'async';
      im.draggable = false;
      track.appendChild(im);
    }
    media.appendChild(track);
    media.classList.add('sgx-swipe');

    var dots = document.createElement('div');
    dots.className = 'sgx-dots';
    for (var d = 0; d < total; d++) dots.appendChild(document.createElement('i'));
    inner.appendChild(dots);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sgx-nav sgx-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEV_L;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sgx-nav sgx-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEV_R;
    inner.appendChild(prev);
    inner.appendChild(next);

    var idx = 0;
    function render(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
      var dotEls = dots.children;
      for (var k = 0; k < dotEls.length; k++) dotEls[k].className = k === idx ? 'on' : '';
      prev.hidden = idx === 0;
      next.hidden = idx === total - 1;
    }
    function go(i) {
      idx = Math.max(0, Math.min(total - 1, i));
      render(true);
    }
    render(false);

    /* arrows (desktop hover) */
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx + 1); });

    /* swipe / drag */
    var dragging = false, axis = null, sx = 0, sy = 0, dx = 0, st = 0, width = 1, suppress = false;

    card.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('.sgx-nav, .quick-add, button, input, select, quantity-input')) return;
      dragging = true;
      axis = null;
      sx = e.clientX;
      sy = e.clientY;
      dx = 0;
      st = Date.now();
      width = media.offsetWidth || 1;
    });

    card.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - sx;
      var dy = e.clientY - sy;
      if (axis === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
        if (axis === 'y') { dragging = false; return; }
        try { card.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var eff = dx;
      if ((idx === 0 && dx > 0) || (idx === total - 1 && dx < 0)) eff = dx / 3;
      track.style.transition = 'none';
      track.style.transform = 'translate3d(calc(' + (-idx * 100) + '% + ' + eff + 'px),0,0)';
    });

    function finish() {
      if (!dragging) return;
      dragging = false;
      if (axis !== 'x') return;
      var elapsed = Math.max(1, Date.now() - st);
      var fast = Math.abs(dx) / elapsed > 0.4 && Math.abs(dx) > 20;
      var far = Math.abs(dx) > Math.max(40, width * 0.15);
      if (far || fast) go(idx + (dx < 0 ? 1 : -1));
      else go(idx);
      suppress = true;
      setTimeout(function () { suppress = false; }, 350);
    }
    card.addEventListener('pointerup', finish);
    card.addEventListener('pointercancel', finish);

    /* a swipe must not open the product page */
    card.addEventListener('click', function (e) {
      if (suppress) {
        e.preventDefault();
        e.stopPropagation();
        suppress = false;
      }
    }, true);
    card.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- find cards, prepare when near the viewport ---------- */
  function prepare(card) {
    var handle = handleOf(card);
    if (!handle) return;
    enqueue(function () { return loadImages(handle); }).then(function (images) {
      if (images && images.length > 1) build(card, images);
    });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            io.unobserve(en.target);
            prepare(en.target);
          }
        });
      }, { rootMargin: '300px' })
    : null;

  function scan() {
    var cards = document.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.__sgxSeen) continue;
      c.__sgxSeen = true;
      if (io) io.observe(c); else prepare(c);
    }
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
